<template>
  <div v-if="!this.$mq.phone" class="dropdown-header-menu" >
    <div class="dropdown-small">
      <b-dropdown :hoverable="true" position="is-bottom-left">
        <button slot="trigger">
          <span>{{ name }}</span>
          <svg-icon name="down-default" class="down-icon" width="12" height="12"></svg-icon>
        </button>
        <b-dropdown-item v-for="link of links" :key="link.name" @click="link.click">{{ link.name }}</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>

import 'top20common/distribution/icons/down-default';

import auth from 'top20common/distribution/services/auth';
import {mapGetters} from 'vuex';

export default {
  props: {
    links: Array
  },
  computed: {
    ...mapGetters(['userDetailsState']),
    isImpersonator() {
      return auth.isImpersonator();
    },
    name() {
      const impersonation = this.$gettext('Impersonating as %{name}');
      const name = this.userDetailsState.first_name
        ? `${this.userDetailsState.first_name} ${this.userDetailsState.last_name}`
        : this.userDetailsState.email;
      return this.isImpersonator ? this.$gettextInterpolate(impersonation, {name}) : name;
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown-header-menu {
  padding: 17px;
  display: flex;
  align-items: center;
}
.dropdown-small {
  padding-top: 0;
  /deep/ .is-hoverable .down-icon {
    margin-top: 1px;
    margin-left: 5px;
    stroke: var(--gray);
  }

  /deep/ .is-hoverable:hover .down-icon {
    stroke: var(--secondary);
  }
}
</style>
